
( function () {
	document.addEventListener( 'DOMContentLoaded', function () {
		var toggles = document.querySelectorAll( '.expand-search__items-toggle' );
		if ( !toggles ) { return; }

		Array.from( toggles ).forEach( ( toggle ) => {
			toggle.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				this.closest( '.expand-search__items--section' ).querySelector( '.expand-search__items-locations' ).classList.toggle( 'expand-search__items-locations--expanded' );
			} );
		} );
	} );
} )();

